import { UserRestriction } from '@/models/user-restriction';

export function getDescription(userRestrictions: UserRestriction[]) {
  if (userRestrictions.length === 0) {
    return 'no_restrictions_label';
  }

  return 'restrictions_label';
}
